import Layout from "@/components/feature/Layout";
import { GUIDE_CHARACTER } from "@/assets/guide";
import authorProfile from "@/assets/author-profile.webp";
import { Link } from "react-router-dom";

const trustItems = [
  { icon: "ri-lock-line", label: "個人情報の入力不要" },
  { icon: "ri-shield-check-line", label: "入力内容はブラウザ内だけで処理" },
  { icon: "ri-calendar-check-line", label: "公式情報と確認日を表示" },
  { icon: "ri-layout-column-line", label: "料金・端末・修理を分けて整理" },
];

const policy = [
  "掲載する料金・条件は、各社公式サイトの一次情報を確認したうえで反映します。",
  "買い切り価格と返却プログラム利用時の負担額は、必ず分けて記載します。",
  "MNP・新規・機種変更・端末のみ購入は区別して案内します。",
  "特定の通信会社のみを一律にすすめる表現は行いません。",
];

export default function About() {
  return (
    <Layout>
      <section className="border-b border-background-300 bg-background-200">
        <div className="mx-auto max-w-[900px] px-4 md:px-6 py-10 md:py-14">
          <div className="text-xs text-secondary-600 font-semibold tracking-widest">この案内所について</div>
          <h1 className="mt-2 text-2xl md:text-3xl font-bold text-foreground-900">むずかしい料金を、判断できる形に整理します</h1>
          <p className="mt-3 text-sm md:text-base text-foreground-600 leading-7">
            スマホ代見直し案内所は、料金・端末・修理・乗り換えの迷いを、ひとつずつ整理する情報サイトです。
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-[900px] px-4 md:px-6 py-12 space-y-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 items-center">
          <div className="md:col-span-1">
            <div className="rounded-xl border border-background-300 bg-background-50 p-6 flex items-end justify-center">
              <img
                src={GUIDE_CHARACTER.src}
                alt={GUIDE_CHARACTER.alt}
                width={GUIDE_CHARACTER.width}
                height={GUIDE_CHARACTER.height}
                className="w-[180px] h-auto"
              />
            </div>
            <p className="mt-3 text-xs text-foreground-500 leading-6 text-center">
              サイトの案内役キャラクターです。実在の専門家や運営者本人ではありません。
            </p>
          </div>
          <div className="md:col-span-2">
            <p className="text-[15px] text-foreground-700 leading-8">
              通信業界で得た知識をもとに、スマホ料金、端末の買い方、修理や乗り換えの注意点を、
              公式情報を確認しながら分かりやすく整理しています。特定の会社だけを一律にすすめず、
              使い方や不安に合う選択肢を比べられる案内所を目指しています。
            </p>
            <div className="mt-5 flex flex-wrap gap-2 text-xs">
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-background-50 border border-background-300 text-foreground-700">
                <i className="ri-check-line text-secondary-500"></i>公式情報をもとに確認
              </span>
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-background-50 border border-background-300 text-foreground-700">
                <i className="ri-check-line text-secondary-500"></i>広告を含む場合はPR表記
              </span>
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-background-50 border border-background-300 text-foreground-700">
                <i className="ri-check-line text-secondary-500"></i>料金・条件には確認日を表示
              </span>
            </div>
          </div>
        </div>

        <div>
          <h2 className="text-xl font-bold text-foreground-900">執筆・内容確認</h2>
          <div className="mt-4 grid gap-5 border-y-2 border-foreground-900 bg-white px-5 py-6 sm:grid-cols-[88px_1fr] sm:items-start md:px-7">
            <img
              src={authorProfile}
              alt="スマートフォンを確認する記事執筆者のプロフィール画像"
              width="88"
              height="88"
              className="h-[88px] w-[88px] rounded-full border border-background-300 bg-background-100 object-cover object-top"
            />
            <div>
              <div className="text-lg font-bold text-foreground-900">スマホ代見直し案内所 編集部</div>
              <p className="mt-3 text-[15px] leading-8 text-foreground-700">
                元キャリアショップ店長・通信業界25年のプロが、料金・端末・乗り換えの情報を、公式情報にもとづいて分かりやすく整理します。
              </p>
            </div>
          </div>
        </div>

        <div>
          <h2 className="text-xl font-bold text-foreground-900">安心して使っていただくために</h2>
          <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-3">
            {trustItems.map((t) => (
              <div key={t.label} className="flex items-center gap-3 p-4 rounded-lg border border-background-300 bg-background-50">
                <span className="w-9 h-9 shrink-0 flex items-center justify-center rounded-md bg-secondary-50 text-secondary-600 text-lg">
                  <i className={t.icon}></i>
                </span>
                <span className="text-sm text-foreground-800">{t.label}</span>
              </div>
            ))}
          </div>
        </div>

        <div>
          <h2 className="text-xl font-bold text-foreground-900">編集方針</h2>
          <ul className="mt-4 space-y-2 text-[15px] text-foreground-700 leading-7">
            {policy.map((p) => (
              <li key={p} className="flex gap-2"><i className="ri-check-line text-secondary-500 mt-1"></i>{p}</li>
            ))}
          </ul>
        </div>

        <div>
          <h2 className="text-xl font-bold text-foreground-900">運営情報</h2>
          <dl className="mt-4 divide-y divide-background-300 border-y border-background-300 text-sm">
            <div className="grid grid-cols-3 py-3"><dt className="text-foreground-500">サイト名</dt><dd className="col-span-2 text-foreground-900">スマホ代見直し案内所</dd></div>
            <div className="grid grid-cols-3 py-3"><dt className="text-foreground-500">サブコピー</dt><dd className="col-span-2 text-foreground-900">通信費をやさしく整理</dd></div>
            <div className="grid grid-cols-3 py-3"><dt className="text-foreground-500">用途</dt><dd className="col-span-2 text-foreground-900">スマホ料金・端末・修理・乗り換えの情報整理</dd></div>
            <div className="grid grid-cols-3 py-3"><dt className="text-foreground-500">お問い合わせ</dt><dd className="col-span-2"><Link to="/contact" className="text-primary-500 underline">お問い合わせ窓口より受付</Link></dd></div>
          </dl>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
          <Link to="/policy" className="p-5 rounded-lg border border-background-300 bg-background-50 hover:border-primary-500"><div className="text-sm font-bold text-foreground-900">編集方針・免責事項</div><div className="mt-1 text-xs text-foreground-600">比較基準と広告方針を確認</div></Link>
          <Link to="/privacy" className="p-5 rounded-lg border border-background-300 bg-background-50 hover:border-primary-500"><div className="text-sm font-bold text-foreground-900">プライバシーポリシー</div><div className="mt-1 text-xs text-foreground-600">入力情報と外部通信について</div></Link>
          <Link to="/contact" className="p-5 rounded-lg border border-background-300 bg-background-50 hover:border-primary-500"><div className="text-sm font-bold text-foreground-900">お問い合わせ</div><div className="mt-1 text-xs text-foreground-600">掲載内容の修正・ご質問</div></Link>
        </div>
      </section>
    </Layout>
  );
}
